module.exports = __webpack_public_path__ + "static/media/university_name.db9cc195.png";